import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthTopBar from "../component/AuthTopBar";
import { Toast } from "../../../components/Toast/Toast";
import { useUserInfo } from "../../../context/user";
import localforage from "localforage";
import ResendEmailModal from "../component/ResendVerifyEmailModal";
import { useUsersContext } from "../../../context/usersContext";
import { CircularProgress } from "@mui/material";
import { useVerifyEmail } from "../../../queries/auth";

const VerifyEmail = () => {
  const verifyEmailMutation = useVerifyEmail();
  const [loader, setLoader] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { agency } = useUsersContext()
  const updateUser = useUserInfo()[1];
  const logout = useUserInfo()[2];
  const navigate = useNavigate();
  const [toast, setToast] = useState({
    message: "",
    type: "error",
    isVisible: false,
    subMessage: "",
  });
  const token = window.location.href.split("=")?.[1];

  useEffect(() => {
    if (token !== "" && token !== undefined && agency) handleVerifyButton();
  }, [token, agency]);

  const handleVerifyButton = async () => {
    setLoader(true);
    let response, error;
    try {
      response = await verifyEmailMutation.mutateAsync({
        token,
        agency_id: agency?._id,
      });
    } catch (err) {
      error = err?.response?.data;
    }
    if (response?.success) {
      setToast({
        message: "Verified Successfully",
        type: "success",
        subMessage: "",
        isVisible: true,
      });
      const { token, ...userData } = response.data;
      await localforage.setItem("token", token);
      updateUser(userData);
      if (response?.data?.user_type === 'integration')
        navigate('/integration-app')
      else
        navigate("/auth/account-setup");
    } else {
      setToast({
        message: error.message,
        type: "error",
        subMessage: "Please try again",
        isVisible: true,
      });
    }
    setLoader(false);
    setTimeout(
      () =>
        setToast(() => ({
          message: error.message,
          type: "error",
          subMessage: "Please try again",
          isVisible: false,
        })),
      3000
    );
  };

  if (token && (toast.message === '' || loader)) {
    return <div className="h-screen w-full flex items-center justify-center"><CircularProgress size={40} /></div>
  }

  return (
    <div className="h-screen bg-background text-foreground">
      <AuthTopBar />
      <div className="relative flex justify-center h-[calc(75%-130px)] items-center">
        <p className="text-muted-foreground absolute top-7 right-12">
          Already have an account?{" "}
          <button
            className="text-foreground font-medium"
            onClick={() => {
              logout();
              navigate("/auth/sign-in");
            }}
          >
            Sign in
          </button>
        </p>
        <div className="text-center">
          <h1 className="text-3xl font-semibold text-foreground">Verify Your Email</h1>
          <p className="max-w-[421px] my-7">
            We've sent a quick verification link to your inbox. Click to
            continue Your AI journey.
          </p>
          <button
            className={`w-full text-center py-4 rounded font-medium bg-foreground text-background border border-foreground transition-colors hover:bg-foreground/90`}
            onClick={() => setIsModalOpen(true)}
          >
            Resend Email
          </button>
        </div>
      </div>
      <Toast
        duration={300}
        message={toast.message}
        subMessage={toast.subMessage ?? ""}
        type={toast.type}
        visible={toast.isVisible}
      />
      <ResendEmailModal
        responseback={(message) =>
          setToast({ isVisible: true, message, type: "success" })
        }
        isModalOpen={isModalOpen}
        justCloseIt={() => setIsModalOpen(false)}
        token={token}
      />
    </div>
  );
};

export default VerifyEmail;
